const scriptIsLoaded = (url: string) => {
  const scripts = document.querySelectorAll('script');
  for (let index = scripts.length; index--; ) {
    if (scripts[index].src === url) {
      return true;
    }
  }
  return false;
};

export default scriptIsLoaded;
